import { loadStripe } from "@stripe/stripe-js"
import { api } from "aldoo-ra/API"

let stripePromise = null

/**
 * Returns a singleton Stripe promise, fetching the publishable key
 * from the server on first call (key lives in ParamIO, not client config).
 */
export function getStripePromise() {
    if (stripePromise) return stripePromise
    const storeAPI = api("store")
    stripePromise = storeAPI({ store_config: true })
        .then((cfg) => {
            const key = cfg?.stripe_publishable_key
            if (!key) return null
            return loadStripe(key)
        })
        .catch((err) => {
            console.error("[Stripe] store_config fetch failed:", err)
            return null
        })
    return stripePromise
}
